import { useTranslation } from "react-i18next";
import { Badge, Grid, Text } from "@mantine/core";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { FormItem } from "../../../../FormItem";
import { RichTextEditor } from "../../../../RichTextEditor";

export interface AssignmentGeneralDetailProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentGeneralDetail = ({ campaign }: AssignmentGeneralDetailProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Grid mb="xs">
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem label={t("campaign_name")}>{campaign?.name || <Text color="dimmed">-</Text>}</FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem label={t("campaign_slug")}>{campaign?.slug || <Text color="dimmed">-</Text>}</FormItem>
                </Grid.Col>
            </Grid>
            {/*
              TTV2-1720: the "Weby" list that used to fill the left column is gone — a campaign
              runs on one web, the one the client already reaches it through. Client and tags
              take a column each so the row keeps the two-column rhythm of the one above it.
            */}
            <Grid mb="xs">
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem mb="xs" label={t("client")}>
                        {campaign?.client?.name || <Text color="dimmed">-</Text>}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem mb="xs" label={t("campaign_tags")}>
                        {!campaign?.tags?.length && <Text color="dimmed">-</Text>}
                        {(campaign?.tags || []).map((tag, index) => (
                            <Badge key={`${index}${tag?.key || tag?.text}`}>{tag?.text || tag?.key}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
            </Grid>
            <FormItem label={t("campaign_description")}>
                {campaign?.description?.json && <RichTextEditor value={{ json: campaign.description.json }} readOnly />}
            </FormItem>
        </>
    );
};
